import { usageTypeData } from '@shared/types';
import {
  Commercial,
  CommercialType,
  Usage,
  UsageCycleNumber,
  UsageCycleUnit,
  UsagePlatform,
  UsageType,
  UsageTypeCategory,
  UsageTypeInfo,
  UsesType,
} from '@talon/web/lib/api';

export const usageTypeIndex: Record<
  string, // CommercialType
  Record<
    string, // UsagePlatform
    Record<
      string, // UsageTypeCategory
      Record<
        string, // UsesType
        | UsageTypeInfo[]
        | Record<
            string, // Cycle label
            UsageTypeInfo[]
          >
      >
    >
  >
> = {
  [CommercialType.TV]: {
    [UsagePlatform.Linear]: {
      [UsageTypeCategory.NationalNetworks]: {
        [UsesType.PerUse]: [usageTypeData[UsageType.TV_LinearDomestic_Network_ClassA_Per_Use]],
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_Network_ClassA_13_Week_Maximum],
          ],
        },
      },
      [UsageTypeCategory.IONAndDiginet]: {
        [UsesType.PerUse]: [usageTypeData[UsageType.TV_LinearDomestic_IONAndDiginet_Per_Use]],
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use],
          ],
        },
      },
      [UsageTypeCategory.SpanishLanguageProgramUse]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_SpanishLanguageProgram_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_SpanishLanguageProgram_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_SpanishLanguageProgram_52_Week],
          ],
        },
      },
      [UsageTypeCategory.Wildspot]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_WildSpot_AllMarkets_4_Week],
            usageTypeData[UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_WildSpot_AllMarkets_13_Week],
            usageTypeData[UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_WildSpot_AllMarkets_52_Week],
            usageTypeData[UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week],
          ],
        },
      },
      [UsageTypeCategory.NationalCable]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_NationalCable_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_NationalCable_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_NationalCable_52_Week],
          ],
        },
      },
      [UsageTypeCategory.LocalCable]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_4_Week],
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week],
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_13_Week],
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week],
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_52_Week],
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week],
            usageTypeData[UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week],
          ],
        },
      },
      [UsageTypeCategory.Dealer]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_Dealer_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_Dealer_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_Dealer_52_Week],
          ],
        },
      },
      [UsageTypeCategory.AllOtherNA]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_AllOtherNALinear_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_AllOtherNALinear_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_LinearDomestic_AllOtherNALinear_52_Week],
          ],
        },
      },
      [UsageTypeCategory.TheatricalIndustrial]: {
        [UsesType.Unlimited]: [
          usageTypeData[UsageType.TV_TheatricalIndustrial_Up_To_30_Days],
          usageTypeData[UsageType.TV_TheatricalIndustrial_Use_Through_MPU],
          usageTypeData[UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media],
        ],
      },
    },
    [UsagePlatform.Digital]: {
      [UsageTypeCategory.TraditionalDigital]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_TraditionalDigital_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_TraditionalDigital_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_TraditionalDigital_52_Week],
          ],
        },
      },
      [UsageTypeCategory.StreamingPlatforms]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_StreamingPlatforms_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_StreamingPlatforms_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_StreamingPlatforms_52_Week],
          ],
        },
      },
      [UsageTypeCategory.SocialMedia]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.thirty} ${UsageCycleUnit.Day}`]: [
            usageTypeData[UsageType.TV_Digital_SocialMedia_30_Day_Cycle],
          ],
        },
      },
      [UsageTypeCategory.YouTube]: {
        [UsesType.Unlimited]: [usageTypeData[UsageType.TV_Digital_SocialMedia_YouTube]],
      },
    },
    [UsagePlatform.TheatricalIndustrial]: {
      [UsageTypeCategory.TheatricalIndustrial]: {
        [UsesType.Unlimited]: [
          usageTypeData[UsageType.TV_TheatricalIndustrial_Up_To_30_Days],
          usageTypeData[UsageType.TV_TheatricalIndustrial_Use_Through_MPU],
          usageTypeData[UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media],
        ],
      },
    },
    [UsagePlatform.Foreign]: {
      [UsageTypeCategory.ForeignUse]: {
        [UsesType.Unlimited]: [
          usageTypeData[UsageType.TV_ForeignUse_SpanishLanguage_Americas],
          usageTypeData[UsageType.TV_ForeignUse_SpanishLanguage_Caribbean],
          usageTypeData[UsageType.TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean],
          usageTypeData[UsageType.TV_ForeignUse_Other_UK],
          usageTypeData[UsageType.TV_ForeignUse_Other_Japan],
          usageTypeData[UsageType.TV_ForeignUse_Other_Europe],
          usageTypeData[UsageType.TV_ForeignUse_Other_RestOfWorld],
          usageTypeData[UsageType.TV_ForeignUse_Other_AsiaPacific],
          usageTypeData[UsageType.TV_ForeignUse_Other_Worldwide],
        ],
      },
    },
    [UsagePlatform.AFM]: {
      [UsageTypeCategory.AFMFirstUse]: {
        [UsesType.Unlimited]: [usageTypeData[UsageType.TV_AFM_FirstUse_InternetOnlyOrUS]],
      },
      [UsageTypeCategory.AFMForeign]: {
        [UsesType.Unlimited]: [
          usageTypeData[UsageType.TV_AFM_Foreign_1_Year_Europe_NoEurope],
          usageTypeData[UsageType.TV_AFM_Foreign_Worldwide],
        ],
      },
    },
  },

  /**
   * Digital
   */
  [CommercialType.Digital]: {
    [UsagePlatform.Digital]: {
      [UsageTypeCategory.TraditionalDigital]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_TraditionalDigital_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_TraditionalDigital_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_TraditionalDigital_52_Week],
          ],
        },
      },
      [UsageTypeCategory.StreamingPlatforms]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_StreamingPlatforms_4_Week],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_StreamingPlatforms_13_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.TV_Digital_StreamingPlatforms_52_Week],
          ],
        },
      },
    },
  },

  /**
   * Social Media
   */
  [CommercialType.Social]: {
    [UsagePlatform.Digital]: {
      [UsageTypeCategory.SocialMedia]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.thirty} ${UsageCycleUnit.Day}`]: [
            usageTypeData[UsageType.TV_Digital_SocialMedia_30_Day_Cycle],
          ],
        },
      },
      [UsageTypeCategory.YouTube]: {
        [UsesType.Unlimited]: [usageTypeData[UsageType.TV_Digital_SocialMedia_YouTube]],
      },
    },
  },

  /**
   * Out-of-Home Use
   */
  [CommercialType.OOH]: {
    [UsagePlatform.TheatricalIndustrial]: {
      [UsageTypeCategory.TheatricalIndustrial]: {
        [UsesType.Unlimited]: [
          usageTypeData[UsageType.TV_TheatricalIndustrial_Up_To_30_Days],
          usageTypeData[UsageType.TV_TheatricalIndustrial_Use_Through_MPU],
          usageTypeData[UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media],
        ],
      },
    },
  },

  /**
   * Radio
   */
  [CommercialType.Radio]: {
    [UsagePlatform.Network]: {
      [UsageTypeCategory.RadioNetwork]: {
        [UsesType.PerUse]: {
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_Network_13_Week_26_Uses],
            usageTypeData[UsageType.Radio_Network_13_Week_39_Uses],
          ],
        },
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.one} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_Network_1_Week_Unlimited_Use],
          ],
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_Network_4_Weeks_Unlimited_Use],
          ],
          [`${UsageCycleNumber.eight} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_Network_8_Weeks_Unlimited_Use],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_Network_13_Week_Unlimited_Use],
          ],
        },
        [UsesType.AcrossTheBoard]: {
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_Network_13_Week_Across_The_Board_Use],
          ],
        },
      },
    },
    [UsagePlatform.WildSpot]: {
      [UsageTypeCategory.RadioWildspot]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.eight} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_WildSpot_8_Week_No_Major_Markets],
            usageTypeData[UsageType.Radio_WildSpot_8_Week_NY_Only],
            usageTypeData[UsageType.Radio_WildSpot_8_Week_LA_Or_Chicago_Only],
            usageTypeData[UsageType.Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago],
            usageTypeData[UsageType.Radio_WildSpot_8_Week_LA_NY_And_Chicago],
          ],
          [`${UsageCycleNumber.thirteen} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_WildSpot_13_Week_No_Major_Markets],
            usageTypeData[UsageType.Radio_WildSpot_13_Week_NY_Only],
            usageTypeData[UsageType.Radio_WildSpot_13_Week_LA_Or_Chicago_Only],
            usageTypeData[UsageType.Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago],
            usageTypeData[UsageType.Radio_WildSpot_13_Week_LA_NY_And_Chicago],
          ],
        },
      },
    },
    [UsagePlatform.Internet]: {
      [UsageTypeCategory.InternetRadio]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.four} ${UsageCycleUnit.Week}`]: [usageTypeData[UsageType.Radio_Internet_4_Week]],
          [`${UsageCycleNumber.eight} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_Internet_8_Week_Made_For],
            usageTypeData[UsageType.Radio_Internet_8_Week_Move_Over],
          ],
          [`${UsageCycleNumber.one} ${UsageCycleUnit.Year}`]: [
            usageTypeData[UsageType.Radio_Internet_1_Year_Made_For],
            usageTypeData[UsageType.Radio_Internet_1_Year_Move_Over],
          ],
        },
      },
    },
    [UsagePlatform.Dealer]: {
      [UsageTypeCategory.RadioDealer]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.eight} ${UsageCycleUnit.Week}`]: [usageTypeData[UsageType.Radio_Dealer_8_Week]],
          [`${UsageCycleNumber.six} ${UsageCycleUnit.Month}`]: [usageTypeData[UsageType.Radio_Dealer_6_Months]],
        },
      },
    },
    [UsagePlatform.AFM]: {
      [UsageTypeCategory.AFMInternetRadio]: {
        [UsesType.Unlimited]: {
          [`${UsageCycleNumber.eight} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_AFM_RadioSpot_Internet_8_Week],
          ],
          [`${UsageCycleNumber.twentySix} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_AFM_RadioSpot_Internet_26_Week],
          ],
          [`${UsageCycleNumber.fiftyTwo} ${UsageCycleUnit.Week}`]: [
            usageTypeData[UsageType.Radio_AFM_RadioSpot_Internet_52_Week],
          ],
        },
      },
    },
  },
};

/**
 * Util Functions
 */

export const getUsageCycleType = (cycleNumber: UsageCycleNumber | null, cycleUnit: UsageCycleUnit | null) =>
  cycleNumber && cycleUnit && `${cycleNumber} ${cycleUnit}`;

export const getMatchingUsageTypeInfos = (usage: Usage, commercial: Commercial) => {
  const usageCycleType = getUsageCycleType(usage.cycle_number, usage.cycle_unit);
  let matchingTypeInfos =
    usage.platform &&
    usage.category &&
    usage.uses_type &&
    Array.isArray(usageTypeIndex[commercial.type]?.[usage.platform]?.[usage.category]?.[usage.uses_type])
      ? (usageTypeIndex[commercial.type]?.[usage.platform]?.[usage.category]?.[usage.uses_type] as UsageTypeInfo[])
      : usageCycleType
        ? (
            usageTypeIndex[commercial.type]?.[usage.platform ?? '']?.[usage.category ?? ''][
              usage.uses_type ?? ''
            ] as Record<string, UsageTypeInfo[]>
        )[usageCycleType]
        : [];

  if (usage.market_spec) {
    matchingTypeInfos = matchingTypeInfos.filter((info) => info.marketSpec === usage.market_spec);
  }

  if (usage.audio_made_move) {
    matchingTypeInfos = matchingTypeInfos.filter((info) => info.audioMadeMove === usage.audio_made_move);
  }

  return matchingTypeInfos;
};

export const getUsagePlatforms = (commercialType: CommercialType) =>
  Object.keys(usageTypeIndex[commercialType]) as UsagePlatform[];

export const getUsageCategories = (commercialType: CommercialType, platform?: UsagePlatform | null) => {
  if (platform) {
    return Object.keys(usageTypeIndex[commercialType][platform]) as UsageTypeCategory[];
  }
};

export const getUsageUsesTypes = (
  commercialType: CommercialType,
  platform?: UsagePlatform | null,
  category?: UsageTypeCategory | null
) => {
  if (platform && category) {
    return Object.keys(usageTypeIndex[commercialType][platform]?.[category] ?? []) as UsesType[];
  }
};

export const getUsageCycleTypes = (
  commercialType: CommercialType,
  platform?: UsagePlatform | null,
  category?: UsageTypeCategory | null,
  usesType?: UsesType | null
) => {
  if (platform && category && usesType) {
    const usesTypeInfos = usageTypeIndex[commercialType][platform]?.[category]?.[usesType];
    return usesTypeInfos && !Array.isArray(usesTypeInfos) ? Object.keys(usesTypeInfos) : undefined;
  }
};
